import api from '../../helpers/axios'

export const state = {
    settings: null,
};

export const getters = {
    settings: (state) => state.settings,
};

export const mutations = {
    setSettings(state, newValue) {
        state.settings = newValue;
    }
};

export const actions = {
    saveSettings({commit},  data) {
        return new Promise((resolve) => {
            api.put("/settings", data).then((res) => {

                commit('setSettings',res.data.data)
                resolve(res.data.data)
            })
        });
    },
    getSettings({ commit }) {
        return new Promise((resolve) => {
            api.get("/settings").then((res) => {
                commit("setSettings", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
